import { User } from '@img-arena/consoles-api-streaming'
import type { Column, Filter } from '@/components/table/base'
import type { DGE_UserFilterParamName, DGE_UserSortAttribute } from '@/stores/users/users.dge.store'

export const DGE_TABLE_COLUMNS: Column<User, DGE_UserSortAttribute>[] = [
  {
    type: 'text',
    id: 'fullName',
    label: 'Full Name',
    sortAttribute: 'fullName'
  },
  {
    type: 'text',
    id: 'email',
    label: 'Email',
    sortAttribute: 'email'
  },
  {
    type: 'number',
    id: 'mainNumber',
    label: 'Main Number',
    sortAttribute: 'mainNumber'
  },
  {
    type: 'text',
    id: 'company',
    label: 'Company',
    sortAttribute: 'company'
  },
  {
    type: 'text',
    id: 'role',
    label: 'Role',
    sortAttribute: 'role'
  },
  {
    type: 'text',
    id: 'operator.name',
    label: 'Operator',
    sortAttribute: 'operator'
  },
  {
    type: 'date',
    id: 'lastLogin',
    label: 'Last Active',
    sortAttribute: 'lastLogin',
    dateFormat: 'dd-MM-yyyy HH:mm:ss',
    sx: { whiteSpace: 'nowrap' }
  }
]

export const DGE_TABLE_FILTERS: Filter<User, DGE_UserFilterParamName>[] = [
  {
    type: 'freeTextSearch',
    paramName: 'filter',
    placeholder: 'Search'
  }
]
